module.exports = __webpack_public_path__ + "img/sc-video-title.5ea39109.png";